import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React from 'react'
import styles from './DocTable.module.scss'
import { fmtSize, fmtDate, fileIcon, getDocDate } from '../../utils'
import { IconEye, IconDownload, IconTrash } from '../../icons'
import Avatar from '../Avatar/Avatar'

export default function DocTable({
  docs,
  docType = 'emp',
  showOwner  = false,
  showFlags  = false,
  onToggle,
  onDelete,
  onDownload,
  onPreview,
}) {
  useInterfaceLanguage();
  if (!docs) return <p className={styles.status}>{tr("Загрузка…")}</p>
  if (!docs.length) return <p className={styles.status}>{tr("Нет документов")}</p>

  return (
    <div className={styles.wrap}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>{tr("Документ")}</th>
            {tr(showOwner && <th>{tr("Сотрудник")}</th>)}
            <th>{tr("Размер")}</th>
            <th>{tr("Дата загрузки")}</th>
            {tr(showFlags && <th>{tr("Видимость")}</th>)}
            <th></th>
          </tr>
        </thead>
        <tbody>
          {docs.map(doc => (
            <tr key={doc.id}>
              <td>
                <div
                  className={styles.fileCell}
                  onClick={() => onPreview?.(doc)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={e => e.key === 'Enter' && onPreview?.(doc)}
                >
                  <span className={styles.fileEmoji}>{fileIcon(doc.file_extension)}</span>
                  <span className={styles.fileName}>{tr(doc.title || doc.file_name)}</span>
                  {tr(doc.file_extension && (
                    <span className={styles.extBadge}>{doc.file_extension.toUpperCase()}</span>
                  ))}
                </div>
              </td>

              {tr(showOwner && (
                <td>
                  <div className={styles.ownerCell}>
                    <Avatar src={doc.employee_photo} name={doc.employee_name} size="sm" />
                    <div className={styles.ownerInfo}>
                      <span className={styles.ownerName}>{tr(doc.employee_name)}</span>
                      {tr(doc.employee_dept && (
                        <span className={styles.badge}>{tr(doc.employee_dept)}</span>
                      ))}
                    </div>
                  </div>
                </td>
              ))}

              <td className={styles.meta}>{fmtSize(doc.file_size)}</td>
              <td className={styles.meta}>{fmtDate(getDocDate(doc))}</td>

              {tr(showFlags && (
                <td>
                  <div className={styles.flags}>
                    <button
                      className={doc.is_open ? styles.flagOn : styles.flagOff}
                      onClick={() => onToggle(doc.id, 'is_open')}
                      title={doc.is_open ? tr("Нажмите чтобы ЗАКРЫТЬ доступ в Кыргызкомур") : tr("Нажмите чтобы ОТКРЫТЬ доступ в Кыргызкомур")}
                    >
                      <span className={styles.flagIcon}>{doc.is_open ? '✓' : '✗'}</span>
                      <span className={styles.flagLabel}>{tr("Открыт")}</span>
                      {/* <span className={styles.flagState}>{doc.is_open ? 'ВКЛ' : 'ВЫКЛ'}</span> */}
                    </button>
                    <button
                      className={doc.show_in_dept ? styles.flagOn : styles.flagOff}
                      onClick={() => onToggle(doc.id, 'show_in_dept')}
                      title={doc.show_in_dept ? tr("Нажмите чтобы СКРЫТЬ от отдела") : tr("Нажмите чтобы ПОКАЗАТЬ отделу")}
                    >
                      <span className={styles.flagIcon}>{doc.show_in_dept ? '✓' : '✗'}</span>
                      <span className={styles.flagLabel}>{tr("В отделе")}</span>
                      {/* <span className={styles.flagState}>{doc.show_in_dept ? 'ВКЛ' : 'ВЫКЛ'}</span> */}
                    </button>
                    <button
                      className={doc.show_in_transit ? styles.flagOn : styles.flagOff}
                      onClick={() => onToggle(doc.id, 'show_in_transit')}
                      title={doc.show_in_transit ? tr("Нажмите чтобы ОТКЛЮЧИТЬ транзит") : tr("Нажмите чтобы ВКЛЮЧИТЬ транзит")}
                    >
                      <span className={styles.flagIcon}>{doc.show_in_transit ? '✓' : '✗'}</span>
                      <span className={styles.flagLabel}>{tr("Транзит")}</span>
                      {/* <span className={styles.flagState}>{doc.show_in_transit ? 'ВКЛ' : 'ВЫКЛ'}</span> */}
                    </button>
                  </div>
                </td>
              ))}

              <td>
                <div className={styles.actions}>
                  <button className={styles.btnPreview} onClick={() => onPreview?.(doc)} title={tr("Предпросмотр")}>
                    <IconEye />
                  </button>
                  <button className={styles.btnDl} onClick={() => onDownload(docType, doc.id, doc.file_name)} title={tr("Скачать")}>
                    <IconDownload />
                  </button>
                  {tr(showFlags && (
                    <button className={styles.btnDel} onClick={() => onDelete(doc.id)} title={tr("Удалить")}>
                      <IconTrash />
                    </button>
                  ))}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
